export const ESTADOS = ['Pendiente', 'Realizada', 'Reprogramada', 'Cancelada'];

export const ESTADO_COLORS = {
  Pendiente: '#1677ff',
  Realizada: '#198039',
  Reprogramada: '#fa8c16',
  Cancelada: '#ff4d4f',
};

export const formatHora = (hora) => {
  if (!hora) return '—';
  return String(hora).slice(0, 5);
};

export const formatFecha = (fecha) => {
  if (!fecha) return '—';
  const s = String(fecha);
  if (s.length >= 10) return s.slice(0, 10).split('-').reverse().join('/');
  return s;
};
